import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SettingsContext = createContext(null);

export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    center_name: "Dervan",
    center_subtitle: "",
    primary_color: "#0a66a0",
    address: "",
    phone: "",
    email: "",
    description: "",
    logo_url: "",
  });

  const fetchSettings = async () => {
    // When a token is present, load the full (private) settings via /settings/mine;
    // otherwise fall back to the public branding-only endpoint.
    const hasToken = !!localStorage.getItem("auth_token");
    const url = hasToken ? `${API}/settings/mine` : `${API}/settings`;
    try {
      const { data } = await axios.get(url);
      setSettings((prev) => ({ ...prev, ...data }));
      applyTheme(data.primary_color);
    } catch {
      // Use defaults
    }
  };

  const applyTheme = (color) => {
    if (!color) return;
    document.documentElement.style.setProperty("--color-primary", color);
    // Generate lighter/darker variants
    const hex = color.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    document.documentElement.style.setProperty("--color-primary-rgb", `${r}, ${g}, ${b}`);
    document.documentElement.style.setProperty("--color-primary-light", `rgba(${r}, ${g}, ${b}, 0.1)`);
    document.documentElement.style.setProperty("--color-primary-medium", `rgba(${r}, ${g}, ${b}, 0.2)`);
  };

  const updateSettings = (newSettings) => {
    setSettings(newSettings);
    applyTheme(newSettings.primary_color);
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, updateSettings, fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}
